import { useMultiRecords } from "../../../../../components/hooks";

import {
  FormInputtext,
  FormDropdown,
} from "../../../../../components/formElement";
import { option_isgraduation } from "../../../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModuleProfileEducationLevel({
  options: { setting, getValues, setValue, trigger, setIsFormUpdate, disabled },
}) {
  const { addDetailBlock, deleteMulti, replayMulti, renderMultiRecordsTb } =
    useMultiRecords({
      blockData: {
        education_level: {
          name: "",
          department: "",
          isgraduation: null,
          remark: "",
        },
      },
      updateForm: ({ name, data }) => {
        setValue(name, data);
        trigger(name);
        setIsFormUpdate(true);
      },
    });

  return (
    <>
      {renderMultiRecordsTb({
        columnLength: 2,
        data: getValues("education_level") || [],
        columnKey: "education_level",
        headTemplate: (
          <>
            <tr className="bg-tb-subtitle">
              <th>教育程度</th>
              <th className="w-4rem">動作</th>
            </tr>
          </>
        ),
        bodyTemplate: ({ data, rowIndex }) => (
          <>
            <td>
              <div className="formgrid grid">
                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    學校名稱
                  </label>
                  <div className="col-12 sm:col-8">
                    <FormInputtext
                      setting={setting}
                      data={{
                        name: `education_level[${rowIndex}].name`,
                        disabled: disabled || data.flag === "delete",
                      }}
                    />
                  </div>
                </div>

                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    科系
                  </label>
                  <div className="col-12 sm:col-8">
                    <FormInputtext
                      setting={setting}
                      data={{
                        name: `education_level[${rowIndex}].department`,
                        disabled: disabled || data.flag === "delete",
                      }}
                    />
                  </div>
                </div>

                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    是否畢業
                  </label>
                  <div className="col-12 sm:col-8">
                    <FormDropdown
                      setting={setting}
                      data={{
                        name: `education_level[${rowIndex}].isgraduation`,
                        options: option_isgraduation,
                        optionLabel: "label",
                        optionValue: "value",
                        showClear: false,
                        disabled: disabled || data.flag === "delete",
                      }}
                    />
                  </div>
                </div>

                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    備註
                  </label>
                  <div className="col-12 sm:col-8">
                    <FormInputtext
                      setting={setting}
                      data={{
                        name: `education_level[${rowIndex}].remark`,
                        disabled: disabled || data.flag === "delete",
                      }}
                    />
                  </div>
                </div>
              </div>
            </td>
          </>
        ),
      })}
    </>
  );
}
